import PTs from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import s from './Row.scss';

const Row = ({ children }) => (
  <div className={s.row} role="presentation">
    {children}
  </div>
);

Row.propTypes = {
  children: PTs.node,
};

Row.defaultProps = {
  children: null,
};

export default withStyles(s)(Row);
